import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { FileType } from '../../../../../shared/constants/download.constants';
declare const html2canvas: any;

@Component({
  selector: 'app-download-icon',
  templateUrl: './download-icon.component.html',
  styleUrls: ['./download-icon.component.less']
})
export class DownloadIconComponent implements OnInit {
  @Input() canvas: ElementRef;
  @Input() questionNumber: number;
  @Input() surveyVersionName: string;

  showDropdownDownload = false;
  showLoader = false;
  imageURL = '';
  showClipboard = false;

  private listening = false;
  private globalClick: any;

  constructor(private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  displayDropdownDownload(element) {
    this.showDropdownDownload = !this.showDropdownDownload;
    if (this.showDropdownDownload) {
      this.globalClick = Observable
        .fromEvent(document, 'click')
        .delay(100)
        .do(() => {
          this.listening = true;
        }).subscribe((event: MouseEvent) => {
          this.onGlobalClick(element, event);
        });
    } else {
      this.listening = false;
      this.globalClick.unsubscribe();
    }
  }

  onGlobalClick(element, event: MouseEvent) {
    if (event instanceof MouseEvent && this.listening === true) {
      if (!this.isDescendant(element.target, event.target)) {
        this.showDropdownDownload = false;
        this.listening = false;
        this.globalClick.unsubscribe();
      }
    }
  }

  isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      } else {
        node = node.parentNode;
      }
    }
    return false;
  }

  selectedDownload(fileExtension: string){
    this.renderImageCanvas(fileExtension)
  }

  renderImageCanvas(fileExtension: string) {
    const surveyVersionName = this.surveyVersionName;
    const questionNumber = ("000" + this.questionNumber).slice(-3);
    html2canvas(this.canvas.nativeElement, { backgroundColor: null }).then(canvas => {
        window.saveAs(canvas.toDataURL(), `Q${questionNumber} ${surveyVersionName}.${fileExtension}`);
    });
  }

  get FileType(): typeof FileType {
    return FileType
  }
}






// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/icon-dropdown/download-icon/download-icon.component.ts